export default __webpack_public_path__ + "static/media/Rectangle-Icon.a7f86fd3.svg";